import React from 'react';

import { Box, Button } from '@mui/material';
import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

import { LoanFeesTestIds } from '../../../../../LoanFees.testIds';

const boxStyles = {
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-end',
};

const Controls = ({
  isLoading,
  isFormChanged,
  onSubmit,
  onCancelForm,
  isApplyCicReasonButtonDisplayed = false,
}) => {
  return (
    <Box className="flex justify-end" sx={boxStyles}>
      <Button
        data-testid={LoanFeesTestIds.CONTROLS_CANCEL_BUTTON}
        disabled={isLoading}
        size="small"
        variant="line"
        onClick={onCancelForm}
      >
        Cancel
      </Button>

      {isApplyCicReasonButtonDisplayed && (
        <Button
          data-is-apply-cic-reason="true"
          data-testid={LoanFeesTestIds.CONTROLS_APPLY_CIC_BUTTON}
          disabled={isLoading}
          size="small"
          onClick={onSubmit}
        >
          Apply CIC Reason
        </Button>
      )}

      <Button
        data-testid={LoanFeesTestIds.CONTROLS_SAVE_BUTTON}
        disabled={!isFormChanged || isLoading}
        size="small"
        onClick={onSubmit}
      >
        Save
      </Button>
    </Box>
  );
};

Controls.propTypes = {
  ...WithLoadingPropTypes,
  isFormChanged: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancelForm: PropTypes.func.isRequired,
  isApplyCicReasonButtonDisplayed: PropTypes.bool,
};

export default Controls;
